export const GET_EXTERNAL_LINK = "GET_EXTERNAL_LINK";
export const GET_EXTERNAL_LINK_SUCCESS = "GET_EXTERNAL_LINK_SUCCESS";
export const GET_EXTERNAL_LINK_ERROR = "GET_EXTERNAL_LINK_ERROR";

export const GET_EXTERNAL_LINKS = "GET_EXTERNAL_LINKS";
export const GET_EXTERNAL_LINKS_SUCCESS = "GET_EXTERNAL_LINKS_SUCCESS";
export const GET_EXTERNAL_LINKS_ERROR = "GET_EXTERNAL_LINKS_ERROR";

export const ADD_EXTERNAL_LINK = "ADD_EXTERNAL_LINK";
export const ADD_EXTERNAL_LINK_SUCCESS = "ADD_EXTERNAL_LINK_SUCCESS";
export const ADD_EXTERNAL_LINK_ERROR = "ADD_EXTERNAL_LINK_ERROR";

export const MODIFY_EXTERNAL_LINK = "MODIFY_EXTERNAL_LINK";
export const MODIFY_EXTERNAL_LINK_SUCCESS = "MODIFY_EXTERNAL_LINK_SUCCESS";
export const MODIFY_EXTERNAL_LINK_ERROR = "MODIFY_EXTERNAL_LINK_ERROR";

export const DELETE_EXTERNAL_LINK = "DELETE_EXTERNAL_LINK";
export const DELETE_EXTERNAL_LINK_SUCCESS = "DELETE_EXTERNAL_LINK_SUCCESS";
export const DELETE_EXTERNAL_LINK_ERROR = "DELETE_EXTERNAL_LINK_ERROR";
